import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{pluralize @count \"trial day\"}} {{@text}}\n",{ moduleName: "garaje/pods/components/trial-days-left/message/template.hbs" })